import { Link, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const isHomePage = location.pathname === '/';

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled || !isHomePage ? 'bg-white shadow-md' : 'bg-transparent'
    }`}>
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-4">
        <div className="flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3">
            <img 
              src="https://static.readdy.ai/image/db812a398b3a5f225f48907587ff778a/54bd81e90ee1470e3e6fa64ffca4e524.png" 
              alt="みなとサービス" 
              className="h-12 w-auto"
            />
            <span className={`text-xl font-bold transition-colors ${
              isScrolled || !isHomePage ? 'text-gray-900' : 'text-white'
            }`}>
              赤帽みなとサービス
            </span>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-6">
            <Link 
              to="/" 
              className={`text-sm font-medium transition-colors ${
                isScrolled || !isHomePage 
                  ? 'text-gray-900 hover:text-[#ebe960]' 
                  : 'text-white hover:text-[#ebe960]'
              }`}
            >
              トップ
            </Link>
            <Link 
              to="/moving" 
              className={`text-sm font-medium transition-colors ${
                isScrolled || !isHomePage 
                  ? 'text-gray-900 hover:text-[#ebe960]' 
                  : 'text-white hover:text-[#ebe960]'
              }`}
            >
              引越し
            </Link>
            <Link 
              to="/furniture" 
              className={`text-sm font-medium transition-colors ${
                isScrolled || !isHomePage 
                  ? 'text-gray-900 hover:text-[#ebe960]' 
                  : 'text-white hover:text-[#ebe960]'
              }`}
            >
              家具・家電運搬
            </Link>
            <Link 
              to="/disposal" 
              className={`text-sm font-medium transition-colors ${
                isScrolled || !isHomePage 
                  ? 'text-gray-900 hover:text-[#ebe960]' 
                  : 'text-white hover:text-[#ebe960]'
              }`}
            >
              不用品整理
            </Link>
            <Link 
              to="/cargo" 
              className={`text-sm font-medium transition-colors ${
                isScrolled || !isHomePage 
                  ? 'text-gray-900 hover:text-[#ebe960]' 
                  : 'text-white hover:text-[#ebe960]'
              }`}
            >
              貨物配送
            </Link>
            <Link 
              to="/about" 
              className={`text-sm font-medium transition-colors ${
                isScrolled || !isHomePage 
                  ? 'text-gray-900 hover:text-[#ebe960]' 
                  : 'text-white hover:text-[#ebe960]'
              }`}
            >
              事業概要
            </Link>
            <Link 
              to="/contact" 
              className="bg-[#ebe960] text-gray-900 px-6 py-2.5 rounded-full text-sm font-semibold hover:bg-[#d4d24e] transition-colors whitespace-nowrap cursor-pointer flex items-center gap-2"
            >
              <i className="ri-mail-fill"></i>
              お問い合わせ
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={`lg:hidden flex flex-col items-center justify-center gap-0.5 transition-colors cursor-pointer ${
              isScrolled || !isHomePage ? 'text-gray-900' : 'text-white'
            }`}
            aria-label="メニュー"
          >
            <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
            <span className="text-[10px] font-medium uppercase tracking-wide">MENU</span>
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMobileMenuOpen && (
          <div className="md:hidden absolute top-full left-0 right-0 bg-white shadow-lg border-t border-gray-200">
            <div className="flex flex-col py-4">
              <Link 
                to="/" 
                className="px-6 py-3 text-sm font-medium text-gray-900 hover:bg-[#ebe960]/10 transition-colors"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                トップ
              </Link>
              <Link 
                to="/moving" 
                className="px-6 py-3 text-sm font-medium text-gray-900 hover:bg-[#ebe960]/10 transition-colors"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                引越し
              </Link>
              <Link 
                to="/furniture" 
                className="px-6 py-3 text-sm font-medium text-gray-900 hover:bg-[#ebe960]/10 transition-colors"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                家具・家電運搬
              </Link>
              <Link 
                to="/disposal" 
                className="px-6 py-3 text-sm font-medium text-gray-900 hover:bg-[#ebe960]/10 transition-colors"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                不用品整理
              </Link>
              <Link 
                to="/cargo" 
                className="px-6 py-3 text-sm font-medium text-gray-900 hover:bg-[#ebe960]/10 transition-colors"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                貨物配送
              </Link>
              <Link 
                to="/about" 
                className="px-6 py-3 text-sm font-medium text-gray-900 hover:bg-[#ebe960]/10 transition-colors"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                事業概要
              </Link>
              <Link 
                to="/contact" 
                className="mx-6 mt-2 bg-[#ebe960] text-gray-900 px-6 py-3 rounded-full text-sm font-semibold hover:bg-[#d4d24e] transition-colors text-center whitespace-nowrap cursor-pointer flex items-center justify-center gap-2"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                <i className="ri-mail-fill"></i>
                お問い合わせ
              </Link>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}
